module.exports = __webpack_public_path__ + "static/media/whyImportant_48.aeba5cb0.png";